import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import './style.scss';

const TrendGroupCommentsTooltip = ({ point }) => {
    return (
        <div className='trend-group-comments-tooltip'>
            <div className='subject-text'>{point.count} {translate('ABB.Powertrain.Frontend.comments')}</div>
            <span className='comment-text'>{translate('ABB.Powertrain.Frontend.clickToViewAllComments')}</span>
        </div>
    );
};

TrendGroupCommentsTooltip.propTypes = {
    point: PropTypes.shape({
        count: PropTypes.number.isRequired
    }).isRequired
};

export default TrendGroupCommentsTooltip;
